import { render } from "./DialogRegistry.vue?vue&type=template&id=0e5210fc"
import script from "./DialogRegistry.vue?vue&type=script&lang=js"
export * from "./DialogRegistry.vue?vue&type=script&lang=js"

import exportComponent from "/Users/qiuxiaofeng/Desktop/交接/assistant_eclient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__